import { merge } from 'lodash'
import TimeFilterMessages from '@/enums/modules/dashboard/fulfillmentMetricsTimeFilter.messages'

export default merge(
  {
    'en-US': {
      Title: 'Fulfillment Metrics',
      ErrorMessage: 'Hm... we couldn\'t load your fullfillment metrics. Please refresh your browser and if you have issues, let our support team know.',
      OrdersDelivered: 'Orders Delivered',
      AvgFulfillmentCost: 'Avg Fulfillment Cost',
      AvgTimeToFulfill: 'Avg Days To Fulfill',
      AvgTimeInTransit: 'Avg Days In Transit',
      ShippingMethod: 'Shipping Method',
      AnalyticsDashboardLink: 'View more with our new Analytics dashboard'
    }
  },
  TimeFilterMessages
)
